<script setup>
import { watch, ref, markRaw } from 'vue'
import { useStore } from 'vuex'
import { toast } from 'vue-sonner'
import BackgroundActionToastContent from './BackgroundActionToastContent.vue'

const store = useStore()

// Track which actions we've created toasts for
const toastIds = ref(new Map()) // actionId -> sonnerToastId

// Watch visible background actions - only create/remove toasts, don't update
watch(
    () => store.getters.visibleBackgroundActions,
    (actions, oldActions) => {
        const currentActionIds = new Set(actions.map((a) => a.id))
        const previousActionIds = new Set((oldActions || []).map((a) => a.id))

        // Remove toasts for actions that are no longer visible
        for (const actionId of previousActionIds) {
            if (!currentActionIds.has(actionId) && toastIds.value.has(actionId)) {
                toast.dismiss(toastIds.value.get(actionId))
                toastIds.value.delete(actionId)
            }
        }

        // Create toasts for new actions only
        for (const action of actions) {
            if (!toastIds.value.has(action.id)) {
                // Create new toast - pass actionId, component will watch store for updates
                const sonnerToastId = toast.custom(markRaw(BackgroundActionToastContent), {
                    duration: Infinity, // We'll handle dismissal manually
                    componentProps: { actionId: action.id },
                })
                toastIds.value.set(action.id, sonnerToastId)
            }
        }
    },
    { immediate: true }
)

// Watch for status changes to update toast duration (auto-dismiss completed)
watch(
    () => store.getters.visibleBackgroundActions.map(a => ({ id: a.id, status: a.status })),
    (actionStatuses) => {
        for (const { id, status } of actionStatuses) {
            if (status === 'completed' || status === 'failed') {
                // Toast will be removed when action is removed from store (after auto-close delay)
            }
        }
    },
    { deep: true }
)
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template>
    <!-- Sonner handles the rendering via the Toaster component in DashboardView -->
</template>
